// Create Code Bxgy
export const CREATE_CODE_BXGY_REQUEST = 'CREATE_CODE_BXGY_REQUEST';
export const CREATE_CODE_BXGY_DONE = 'CREATE_CODE_BXGY_DONE';
export const CREATE_CODE_BXGY_FAILED = 'CREATE_CODE_BXGY_FAILED';
export const CREATE_CODE_BXGY_RESET = 'CREATE_CODE_BXGY_RESET';